//*********************************************************************************************************************/
//Require all module.js files in the view_models directory and add them to the global Kadenze namespace
//For example, a module from /some/awesome/feature/module.js will be stored in Kadenze.SomeAwesomeFeature
//To invoke the module, set data-module-amd attribute to 'SomeAwesomeFeature'
//Modules are responsible for loading their own dependencies
//*********************************************************************************************************************/
function requireModule(path) {
  var moduleName = path.split('/').map(s.capitalize).map(s.camelize).join('');
  require(['./view_models/' + path + '/module'], function (module) {
    Kadenze[moduleName] = module.default;
  });
}

require('load-globals');
requireModule('user/registration');

requireModule('user/account_settings');

requireModule('common/top_nav');
requireModule('common/course/public_info');
requireModule('common/course/syllabus');
requireModule('common/course/block_syllabus');

requireModule('common/program/show');
requireModule('common/program/listing');
requireModule('common/program/homepage_listing');
requireModule('common/course/list');
requireModule('common/course/my_courses');

requireModule('kadenze_public/pricing_and_membership');
requireModule('kadenze_public/faqs');
requireModule('kadenze_public/press');
requireModule('kadenze_public/homepage');
requireModule('kadenze_public/partner/show');
requireModule('kadenze_public/prospective_student');
requireModule('kadenze_public/hero/slider');
requireModule('kadenze_public/hero/video');
requireModule('kadenze_public/transition_scene');

requireModule('common/error/show');
requireModule('common/site_alert');

requireModule('common/parallax');

requireModule('user/confirmation_required');
requireModule('user/enrollment_info');

requireModule('common/notification_center');
requireModule('common/search/results');
